export default "__VITE_ASSET__ab57aad5__"